/**
 * tablesort_numeric.js
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import tablesort from "tablesort";

const pattern = val => val === "*" || !isNaN(parseFloat(val));

const compare = (a, b) => {
    let floatA = a === "*" ? -1 : parseFloat(a.replace(/,/g, ""));
    let floatB = b === "*" ? -1 : parseFloat(b.replace(/,/g, ""));

    if (isNaN(floatA)) {
        floatA = 0;
    }
    if (isNaN(floatB)) {
        floatB = 0;
    }

    return floatA - floatB;
};

tablesort.extend("number", pattern, compare);
